/**
 * 
 * @param {Blob} file 
 * @returns 
 */
export const READ_FILE = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener("loadend", e => {
            console.log(e.target.result);
            resolve(e.target.result);
        });
        reader.addEventListener("error", reject);

        reader.readAsArrayBuffer(file);
    })
}

export const READ_FILE_AS_DATA_URL = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener("loadend", e => {
            console.log(e.target.result);
            console.log(e);
            resolve(e.target.result);
        });
        reader.addEventListener("error", reject);

        reader.readAsDataURL(file);
    })
}